import React from 'react';
import { Icon } from '../../../../foundations/Icon';
import { forwardRef } from '../../../../utils';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Box } from '../../Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CreatableMessage = forwardRef((_ref, ref) => {
  var {
    children
  } = _ref;
  var style = useMultiStyleConfig('Select', {});
  return /*#__PURE__*/_jsxs(Box, {
    __css: style['creatableMessage'],
    "data-testid": "select-create-label",
    ref: ref,
    children: [/*#__PURE__*/_jsx(Icon, {
      type: "add",
      size: "small",
      color: "inherit"
    }), /*#__PURE__*/_jsx(Box, {
      as: "p",
      children: children
    })]
  });
});
CreatableMessage.displayName = 'CreatableMessage';
//# sourceMappingURL=CreatableMessage.js.map